// src/App.jsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "@/contexts/AuthContext";

import Login from "./pages/Login";
import Users from "./pages/Users";
import Bots from "./pages/Bots";
import BotUsers from "./pages/BotUsers";
import BotRules from "./pages/BotRules";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/common/ErrorBoundary";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { useAuth } from "@/contexts/AuthContext";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

// 將 PrivateRoute 移到 Router 內部的組件中
const AppContent = () => {
  const PrivateRoute = ({ children }) => {
    const { authenticated, loading } = useAuth();
    console.log(authenticated);

    if (loading) {
      return <LoadingSpinner />;
    }

    if (!authenticated) {
      return <Navigate to="/login" />;
    }

    return <Layout>{children}</Layout>;
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/bots"
        element={
          <PrivateRoute>
            <Bots />
          </PrivateRoute>
        }
      />
      <Route
        path="/bot-users"
        element={
          <PrivateRoute>
            <BotUsers />
          </PrivateRoute>
        }
      />

      <Route
        path="/bot-rules"
        element={
          <PrivateRoute>
            <BotRules />
          </PrivateRoute>
        }
      />

      <Route path="/" element={<Navigate to="/users" />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <Router>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </Router>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
